import Vue from "vue";
import OutdatedBrowser from "outdated-browser-rework";
import jQuery from "jquery";
import DataWebConfig from "@Scripts/Config/DataWebConfig";
import { router } from "@Scripts/Config/RouteConfig";
import { store } from "@Scripts/Config/StoreConfig";
import Axios from "axios";
import AppConfig from "@Scripts/Config/AppConfig";
import Localizer from "@Scripts/Common/Localizer";

export default class BasePage {
    public static async init() {
		await Localizer.init({
            defaultCulture: (<any>window).App.culture,
            resourceContexts: ["App"]
        });

        this.initRequestVerificationToken();

        // DataWeb setup
        let DataWeb = (<any>window).DataWeb;
        if (DataWeb) {
            Vue.use(DataWeb.default);
            Vue.use(DataWebConfig);

            await DataWeb.Localizer.init({ defaultCulture: (<any>window).App.userCulture, resourceContexts: ["DataWeb", "Account"] });
        }

        AppConfig.AddComponents();

        let vm = new Vue({
            el: "#app",
            router,
            store,
            created() {
                if (DataWeb) {
                    DataWeb.default.registerRoutes(router);
                    DataWeb.default.registerStoreModules(store);
                }
            }
        });

        (<any>window).App.instances.vm = vm;

        this.resetCssAnimations();
        this.zombieBrowsers();
        this.setFancyBox();
        this.setPagination();
        this.setResponsive();
        this.setShareButton();
    }

    private static initRequestVerificationToken() {
        var antiforgerytoken = (<any>document.getElementsByName("__RequestVerificationToken")[0]).value;
        if (antiforgerytoken) {
            Axios.defaults.headers.common["RequestVerificationToken"] = antiforgerytoken;
        }
    }

    private static resetCssAnimations() {
        // Styles animations reset
        (<any>window).addEventListener("load", function () {
            let loaders = document.getElementsByClassName("loader");
            for (let i = 0; i < loaders.length; i++) {
                loaders[i].classList.add("hide");
            }

            let preLoaders = document.querySelectorAll("[data-preload]");
            for (let i = 0; i < preLoaders.length; i++) {
                preLoaders[i].removeAttribute("data-preload");
            }
        });
    }

    private static zombieBrowsers() {
        OutdatedBrowser({
            browserSupport: {
                "IE": false
            },
            bgColor: "#E18300",
            color: "#ffffff"
        });
    }

    private static setFancyBox() {
        jQuery("[data-fancybox]").fancybox({
            buttons: [
                "close"
            ]
        });

        jQuery("[data-fancybox=\"nl\"]").fancybox({
            baseClass: "fncy-nl"
        });

        jQuery("[data-fancybox=\"info\"]").fancybox({
            baseClass: "fncy-info"
        });

        jQuery(".close-fancy").click(function () {
            (<any>parent).jQuery.fancybox.close(true);
        });
    }

    private static setPagination() {
        let pageIndexList = document.getElementById("PageIndexList") as HTMLSelectElement;

        if (pageIndexList) {
            pageIndexList.addEventListener("change", function () {
                window.location.href = pageIndexList.options[pageIndexList.selectedIndex].getAttribute("data-url");
            });
        }
    }

    private static setResponsive() {
        let openSearchButton = document.getElementById("OpenSearchButton"),
            closeSearchButton = document.getElementById("CloseSearchButton"),
            searchBox = document.getElementById("SearchBox"),
            wrapTap = document.getElementById("WrapTap"),
            openMenuButton = document.getElementById("OpenMenuButton"),
            menuBox = document.getElementById("MenuBox");

        if (openSearchButton) {
            openSearchButton.addEventListener("click", function () {
                searchBox.classList.add("show");
                wrapTap.classList.add("show");
                wrapTap.classList.add("white");
            });
        }

        if (closeSearchButton) {
            closeSearchButton.addEventListener("click", function () {
                searchBox.classList.remove("show");
                wrapTap.classList.remove("show");
                wrapTap.classList.remove("white");
            });
        }

        if (openMenuButton) {
            openMenuButton.addEventListener("click", function () {
                menuBox.classList.add("show");
                wrapTap.classList.add("show");
            });
        }

        if (wrapTap) {
            wrapTap.addEventListener("click", function () {
                menuBox.classList.remove("show");
                searchBox.classList.remove("show");
                wrapTap.classList.remove("show");
                wrapTap.classList.remove("white");
            });
        }

        let categories = document.querySelectorAll("[data-open]"),
            subCategoriesList = document.querySelectorAll("[data-list]"),
            subCategoriesBackButton = document.querySelectorAll("[data-back]");
        for (let i = 0; i < categories.length; i++) {
            categories[i].addEventListener("click", function () {
                subCategoriesList[i].classList.add("show");
            });

            subCategoriesBackButton[i].addEventListener("click", function () {
                subCategoriesList[i].classList.remove("show");
            });

            wrapTap.addEventListener("click", function () {
                subCategoriesList[i].classList.remove("show");
            });
        }
    }

    private static setShareButton() {
        let openShare = document.getElementById("OpenShare");
        let shareBox = document.getElementById("ShareBox");

        if (openShare) {
            openShare.addEventListener("click", function () {
                shareBox.classList.toggle("show");
            });
        }
    }
}